import React from 'react';

export const ArrowDown: React.FC = () => {
  return (
    <svg
      width="15"
      height="8"
      viewBox="0 0 15 8"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M13.749 1L7.49359 7.25L1.23816 1"
        stroke="#697684"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
